export default ({ request }) => ({

  listResearchInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/researchInputTemplate/list',
      method: 'post',
      data
    })
  },
  saveResearchInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/researchInputTemplate/save',
      method: 'post',
      data
    })
  },
  detailResearchInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/researchInputTemplate/detail',
      method: 'post',
      data
    })
  },
  delResearchInputTemplateApi(data) {
    return request({
      url: '/digitalCenter/researchInputTemplate/del',
      method: 'post',
      data
    })
  }
})
